import { cn } from '@endure/ui';
import { useState } from 'react';

import { Icon, Modal } from 'components';
import { useTranslation } from 'libs/translations';
import { NavButtonWrapper } from '../NavButtonWrapper';
import { Settings } from '../Settings';

export interface SettingsButtonProps {
  className?: string;
  iconClassName?: string;
}

export const SettingsButton: React.FC<SettingsButtonProps> = ({ className, iconClassName }) => {
  const { t } = useTranslation();

  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const openSettingsModal = () => setIsSettingsModalOpen(true);
  const closeSettingsModal = () => setIsSettingsModalOpen(false);

  return (
    <>
      <NavButtonWrapper
        aria-label={t('layout.settingsModal.title')}
        className={cn('size-9 sm:size-12 xl:hidden', className)}
        onClick={openSettingsModal}
      >
        <Icon name="gearFull" className={cn('text-muted', iconClassName)} />
      </NavButtonWrapper>

      <Modal
        isOpen={isSettingsModalOpen}
        handleClose={closeSettingsModal}
        title={t('layout.settingsModal.title')}
        className="overflow-visible"
      >
        <Settings />
      </Modal>
    </>
  );
};
